/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const UpgradeModalRoot = styled.div`
  width: 800px;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 20px 0 20px;
  border-radius: 8px;
  background-color: ${props => props.theme.surface[2]};
  border: 1px solid ${props => props.theme.border.decorative};
  color: ${props => props.theme.text.primary};
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.font};
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  margin-top: -5%;
  @media (max-width: 840px) {
    width: 95%;
    margin: 0 auto;
  }
`;

export const TilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalTitle = styled.h3`
  font-family: ${props => props.theme.font};
  margin: 0 0 4px;
  color: ${props => props.theme.text.primary};
`;

export const ModalSubtitle = styled.p`
  font-family: ${props => props.theme.font};
  margin: 0 0 20px;
  color: ${props => props.theme.text.tertiary};
`;

export const ModalContentHeader = styled.p`
  font-family: ${props => props.theme.font};
  margin: 0 0 20px;
  color: ${props => props.theme.text.secondary};
`;

export const ModalButtonWrapper = styled.div`
  font-family: ${props => props.theme.font};
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 12px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.surface[2]};
  padding: 20px 0px 20px 0px;
  margin: 20px 0 0 0;
  border-top: 1px solid ${props => props.theme.border.decorative};
`;
